export default __webpack_public_path__ + "static/media/es.f53b852b.svg";